module.exports = __webpack_public_path__ + "static/media/CS_ROI.6427fa36.png";